import { colors } from '../../colors';
var location = {
  bgColor: colors.powder,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black
};
export default location;